import { render } from "./ContentDetailDeposito.vue?vue&type=template&id=1be39e87&scoped=true"
import script from "./ContentDetailDeposito.vue?vue&type=script&lang=js"
export * from "./ContentDetailDeposito.vue?vue&type=script&lang=js"

import "./ContentDetailDeposito.vue?vue&type=style&index=0&id=1be39e87&lang=scss&scoped=true"

import exportComponent from "C:\\Programming\\Padmaweb\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1be39e87"]])

export default __exports__